import { useEffect, useState } from "react";

import {

    getCustomerOrders,

    cancelOrder,

} from "../services/orderService";

function useOrders() {

    const [orders, setOrders] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    // =====================================
    // Fetch Orders
    // =====================================

    const fetchOrders = async () => {

        try {

            setLoading(true);

            setError("");

            const res = await getCustomerOrders();

            if (res.success) {

                setOrders(res.orders);

            }

        }

        catch (err) {

            console.log(err);

            setError(

                err.response?.data?.message ||

                "Failed to fetch orders."

            );

        }

        finally {

            setLoading(false);

        }

    };

    // =====================================
    // Cancel Order
    // =====================================

    const handleCancelOrder = async (orderId) => {

        try {

            const res = await cancelOrder(orderId);

            alert(res.message);

            fetchOrders();

        }

        catch (err) {

            alert(

                err.response?.data?.message ||

                "Unable to cancel order."

            );

        }

    };

    useEffect(() => {

        fetchOrders();

    }, []);

    // =====================================
    // Active Orders
    // =====================================

    const activeOrders = orders.filter(

        (order) =>

            ![

                "Delivered",

                "Cancelled",

                "Rejected",

            ].includes(order.status)

    );

    // =====================================
    // Previous Orders
    // =====================================

    const previousOrders = orders.filter(

        (order) =>

            [

                "Delivered",

                "Cancelled",

                "Rejected",

            ].includes(order.status)

    );

    return {

        loading,

        error,

        orders,

        activeOrders,

        previousOrders,

        fetchOrders,

        handleCancelOrder,

    };

}

export default useOrders;